export const CreditReportTypes = Object.freeze({
  Experian: 'Experian',
  CreditSafe: 'CreditSafe',
});
